import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'o3-core-app-notifications-bar',
  imports: [CommonModule],
  templateUrl: './app-notifications-bar.html',
  styleUrl: './app-notifications-bar.scss',
})
export class AppNotificationsBar {
  isNotificationsbarCollapsed = input<boolean>(true);
}
